// extracted by mini-css-extract-plugin
export default {"submenu":"Submenu_submenu__LUxnn","selected":"Submenu_selected__suugr"};